import { RoleType } from "./roles";

export enum UsersAction {
  REPLACE_USERS = "REPLACE_USERS",
  ADD_USER = "ADD_USER",
  UPDATE_USER = "UPDATE_USER",
  DELETE_USER = "DELETE_USER",
}

export type ManagedUser = {
  _id: string;
  userid: string;
  firstName: string;
  lastName: string;
  roles: RoleType[];
};

export type UsersType = { [group: string]: ManagedUser[] };

export type WelcomeEmailResponse = {
  apiName: string;
  status: string;
  code: number;
  message: string;
  results: string[];
};

interface ReplaceUsers {
  type: UsersAction.REPLACE_USERS;
  users: UsersType;
}
interface AddUser {
  type: UsersAction.ADD_USER;
  user: ManagedUser;
  groupKey: string;
}
interface UpdateUser {
  type: UsersAction.UPDATE_USER;
  user: ManagedUser;
}
interface DeleteUser {
  type: UsersAction.DELETE_USER;
  userId: string;
}

export type UsersActionTypes = ReplaceUsers | AddUser | UpdateUser | DeleteUser;
